import { Password } from "@swa-ui/core";
import { withFormField } from "@swa-ui/form";

/**
 * PasswordFormField provides support for a standard Password component to be used in a Form.
 */

export const PasswordFormField = withFormField(Password);
